import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { BulkAssignResponse, BulkAssignServiceRequestsProps } from './types';

type AssignServiceRequestsToFirmParams = {
  agentFirmId: string;
  data: BulkAssignServiceRequestsProps;
};

export async function assignServiceRequestsToFirm({
  agentFirmId,
  data,
}: AssignServiceRequestsToFirmParams) {
  const response = await fetcher(`${API_BASE_PATH}/${agentFirmId}/assign`, {
    method: 'POST',
    body: data,
  });

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error:
        responseData?.message || 'Failed to assign service requests to firm',
      statusCode: response.status,
    };
  }

  const responseData: BulkAssignResponse = await response.json();
  return {
    success: true,
    data: responseData,
  };
}
